import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppState {
  // UI State
  sidebarOpen: boolean
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void

  // Selected portfolio
  selectedPortfolioId: number | null
  setSelectedPortfolioId: (id: number | null) => void

  // Theme
  theme: 'light' | 'dark' | 'system'
  setTheme: (theme: 'light' | 'dark' | 'system') => void

  // Locale
  locale: 'ru' | 'en'
  setLocale: (locale: 'ru' | 'en') => void

  // Currency display
  baseCurrency: string
  setBaseCurrency: (currency: string) => void
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      // UI State
      sidebarOpen: typeof window !== 'undefined' && window.innerWidth >= 1024,
      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),

      // Selected portfolio
      selectedPortfolioId: null,
      setSelectedPortfolioId: (id) => set({ selectedPortfolioId: id }),

      // Theme
      theme: 'light',
      setTheme: (theme) => set({ theme }),

      // Locale
      locale: 'ru',
      setLocale: (locale) => set({ locale }),

      // Currency
      baseCurrency: 'RUB',
      setBaseCurrency: (currency) => set({ baseCurrency: currency }),
    }),
    {
      name: 'elvirka-storage',
      partialize: (state) => ({
        theme: state.theme,
        locale: state.locale,
        baseCurrency: state.baseCurrency,
        selectedPortfolioId: state.selectedPortfolioId,
      }),
    }
  )
)
